import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import { Button, Card, Checkbox, Form, Row, Icon, Col, notification, Popconfirm, Select, Table, Tabs, Tooltip, Drawer } from 'antd'
import _ from 'lodash'
import async, { forEach } from 'async';
import { hideLoader, showLoader } from '../../../modules/actions'
import Request, { API_URL } from '../../../request'
import { connect } from 'react-redux'
import styles from '../../Desk/registration/all/styles.less'
import common from '../../common.less'
import stylesNew from './styles.less'

import setting from '../../../components/_utils/settings'
import moment from 'moment'

const Option = Select.Option

const TabPane = Tabs.TabPane


const nameValue = {
    v: 'view',
    vb: 'BranchWiseView',
    vu: 'UserWiseView',
    a: 'add',
    e: 'edit',
    d: 'delete'
}

const keyValue = {
    view: 'v',
    BranchWiseView: 'vb',
    UserWiseView: 'vu',
    viewByBranch: 'vb',
    viewById: 'vu',
    add: 'a',
    edit: 'e',
    delete: 'd'
}


// following variables needed for update country
let docLoaded = null
let countryId = null

@Form.create()
class FormComp extends Component {
    handleSubmit = e => {
        const { form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                valData.dashboard = valData.dashboard ? valData.dashboard : 'Counsellor'
                this.props.handleSubmit(valData)

            }
        })
    }

    componentDidMount() {
        const {
            form: { setFieldsValue }
        } = this.props

        const { data } = this.props

        if (!!data) {
            setFieldsValue(data)
        }
    }

    render() {
        const {
            form: { getFieldDecorator }
        } = this.props

        let inputTypes = {
            fields: [{ label: 'Group Name', key: 'groupName', required: true, showSearch: true },
            {
                label: 'Dashboard',
                type: 'select',
                key: 'dashboard',
                showSearch: true,
                options: [
                    'FrontOffice',
                    'Tellecaller',
                    'LeadManager',
                    'OfficeManager',
                    'OperationManager',
                    'Counsellor',
                    'Registration',
                    'Admission',
                    'VisaSupport',
                    'VisaFilling',
                    'ClaimCommission',
                    'FinanceCommission',
                    'RelationshipManager',
                    'BusinessDevelopment',
                    'Marketing',
                    'DataOperations',
                    'Vision',
                    'HR'
                ],
                onChange: Dashboard => {
                    this.props.form.setFieldsValue({
                        dashboard: Dashboard
                    })
                }
            }
            ]
        }
        // const formItemLayout = {
        //     labelCol: {
        //         xs: {span: 24},
        //         sm: {span: 8},
        //         md: {span: 8}
        //     },
        //     wrapperCol: {
        //         xs: {span: 24},
        //         sm: {span: 16},
        //         md: {span: 12}
        //     }
        // }
        // const submitFormLayout = {
        //     wrapperCol: {
        //         xs: {span: 24, offset: 0},
        //         sm: {span: 10, offset: 7},
        //         md: {span: 12, offset: 8}
        //     }
        // }

        return (
            <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                    inputSchema={inputTypes}
                    getFieldDecorator={getFieldDecorator}
                />
                <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginBottom: 10, marginLeft: '33%' }}
                    loading={this.props.loading}>
                    SAVE
                </Button>
            </Form>
        )
    }
}

@Form.create()
class RightsToAll extends Component {
    state = {
        visible: true,
        modules: [],
        groupsData: [],
        extraModules: [],
        moduleNames: []
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    getAllData = () => {
        let { groups, moduleNames, groupsArray } = this.props;
        let modules = []
        let groupsData = []
        for (const key in groupsArray) {
            if (groupsArray[key]) {
                async.each(groupsArray[key], (module) => {
                    if (module.displayName !== undefined) {
                        modules.push({ _id: module._id, display: module.displayName, rightName: module.rightName, type: module.type })
                    }

                })
            }
        }
        async.each(groups, (group) => {
            groupsData.push({ id: group._id, display: group.groupName })
        })
        this.setState({ modules, groupsData })
    }


    setOtherFields = (rightId) => {
        let { modules } = this.state;
        let foundModule = modules.find((obj) => {
            return obj._id === rightId
        })
        this.setState({ extraModules: [] })
        let moduleTypes = foundModule.type.split(',')
        const fieldsArray = {
            "v": 'view',
            "vu": 'viewById',
            "vb": "viewByBranch",
            "a": "add",
            "e": "edit",
            "d": "delete"
        }
        const moduleNames = []
        async.each(moduleTypes, (module) => {
            if (fieldsArray[module.trim()]) { // Check if the module exists in fieldsArray
                moduleNames.push(fieldsArray[module.trim()]);
            }
        })
        this.setState({ moduleNames })

    }

    componentDidMount() {
        this.getAllData();
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let { form } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            let response = await Request.giveRightsToAll(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }

    render() {
        let { visible, modules, groupsData, extraModules, moduleNames } = this.state;
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        let inputTypes = {
            fields: [
                {
                    label: 'Select Rights',
                    key: 'rightId',
                    type: 'select',
                    showSearch: true,
                    options: modules,
                    required: true,
                    onChange: v => {
                        setFieldsValue({ rightId: v })
                        this.setOtherFields(v)
                    }
                },
                {
                    label: 'Right Type',
                    key: 'rightTypes',
                    type: 'select',
                    showSearch: true,
                    options: moduleNames,
                    mode: 'multiple',
                    required: true,
                    onChange: v => {
                        setFieldsValue({ rightTypes: v })
                    }
                },
                {
                    label: 'Select Group',
                    key: 'group',
                    type: 'select',
                    mode: 'multiple',
                    showSearch: true,
                    required: true,
                    options: groupsData,
                    onChange: v => {
                        setFieldsValue({ group: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Add Rights
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields
                            apiurl={API_URL}
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                        />
                        {extraModules}
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

@Form.create()
class AddGroup extends PureComponent {
    state = {
        rightName: '',
        id: '',
        count: 0,
        data: [],
        checkedRights: {},
        groupCount: '',
        activeKey: '0',
        masterRightObj: {},
        newRights: [],
        moduleNames: [],
        moduleName: '',
        allowedRights: [],
        groupsArray: [],
        showRightsDrawer: false,
        groups: []
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.groupTable = React.createRef()
    }

    callback = key => {
        let inputTypes = this.state.inputTypes

        if (countryId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
            inputTypes[key - 1].opened = true
            let tempObj = {}
            _.each(inputTypes[key - 1].fields, (v, k) => {
                tempObj[v.key] = docLoaded[v.key]
            })


            setTimeout(() => {
                this.props.form.setFieldsValue(tempObj)
            }, 10)
        }
    }

    handleSubmit = async valData => {
        const { dispatch } = this.props
        const { editingGroup } = this.state

        dispatch(showLoader())

        let x = {}

        if (editingGroup) {
            valData._id = editingGroup._id
            let rights = []
            _.each(editingGroup.rights, item => {
                if (!item.title) {
                    delete item.temp
                    if (
                        item.add ||
                        item.edit ||
                        item.delete ||
                        item.view ||
                        item.viewByBranch ||
                        item.viewById
                    ) {
                        rights.push(item)
                    }
                }
            })
            x = await Request.updateUserGroup({ ...valData, rights })
            dispatch(hideLoader())
        } else {
            let y = this.state.data
            let rights = []
            _.each(y, item => {
                if (!item.title) {
                    delete item.temp
                    if (
                        item.add ||
                        item.edit ||
                        item.delete ||
                        item.viewByBranch ||
                        item.viewById ||
                        item.view
                    ) {
                        rights.push(item)
                    }
                }
            })
            x = await Request.addUserGroup({ ...valData, rights })
            dispatch(hideLoader())
        }

        if (x) {
            if (!x.error) {
                notification.success({
                    message: editingGroup ? `Updated Successfully` : 'Added successfully'
                })
                if (!editingGroup) {
                    this._isSelectAll(false)
                    this.props.form.resetFields()
                }
            } else {
                notification.error({
                    message: 'Error Saving',
                    description: x.message
                })
            }
        } else {
            notification.error({
                message: 'Error Saving',
                description: 'Error Saving'
            })
        }

    }

    onChange(e) {
        console.log(`checked = ${e.target.checked}`)
    }

    changeRightsCheckbox = (type, checked, record) => {

        let temp = _.clone(this.state.data)

        if (record) {
            let single = _.find(temp, x => x.rightId === record.rightId)
            single[type] = checked

        } else {
            _.each(temp, single => {
                if (single[type] !== undefined) {
                    single[type] = checked
                }
            })
        }

        this.setState({
            data: temp
        })
    }


    changeRightsCheckbox2 = (type, checked, record) => {
        let temp = _.clone(this.state.editingGroup)
        if (record) {
            let single = _.find(temp.rights, x => x.rightId === record.rightId)
            single[type] = checked
        } else {
            _.each(temp.rights, single => {
                if (single[type] !== undefined) {
                    single[type] = checked
                }
            })
        }

        this.setState({
            editingGroup: temp
        })
    }
    apiRequest = async (params, columns) => {
        return new Promise(async (resolve) => {
            if (!params) {
                params = {
                    sortField: 'rightName',
                    sortOrder: 'ascend'
                }
            } else {
                params.sortField = 'rightName'
                params.sortOrder = 'ascend'
            }

            let { groupData, groupsArray } = await Request.loadGroupedRights({ results: 10000, count: 10000, ...params, regExFilters: ["displayName"], })
            let data = groupData
            let x = []
            let newRights = []
            let moduleNames = [];
            _.each(data, (item, key) => {
                newRights.push({ title: key })
                item = _.sortBy(item, (itemO) => {
                    return itemO.order
                })
                _.each(item, (item1) => {
                    moduleNames.push(item1.displayName)
                    newRights.push(item1)
                })
            })
            this.setState({ moduleNames });

            if (newRights) {
                let masterRightObj = {}
                _.each(newRights, (item, key) => {
                    if (item && (item.type || item.title)) {
                        masterRightObj[item.rightName] = item.type
                        let splitData = []
                        if (item.type) {
                            splitData = item.type.split(',')
                        }
                        let y = {
                            rightId: item._id,
                            rightName: item.rightName,
                            displayName: item.displayName,
                            group: item.group,
                            groupOrder: item.groupOrder,
                            order: item.order
                        }
                        _.each(splitData, (item1) => {
                            if (item1) {
                                item1 = item1.trim()
                            }
                            y[nameValue[item1]] = false
                        })
                        if (item.title) {
                            y.title = item.title
                        }
                        x.push(y)
                    }
                })


                this.setState({
                    data: x,
                    groupsArray,
                    masterRightObj: masterRightObj
                })
                resolve(x)
            }
        })
    }

    groupRequestApi = async (params, columns) => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'groupName'
                params.sortOrder = 'ascend'
            }
            if (this.state.moduleName) {
                params.moduleName = this.state.moduleName
            }
            let data = await Request.loadGroups({
                ...params,
                regExFilters: ['groupName']
            })
            this.setState({ groupCount: data.total, groups: data.data })
            resolve(data)
        })
    }

    deleteUserGroup = async data => {
        this.setState({ loading: true })
        let doc = await Request.deleteUserGroup(data)
        if (doc) {
            if (doc.error) {
                notification.error({
                    message: doc.message,
                    duration: 20,
                    key: `${data._id}-close`
                })
            } else {
                notification.success({
                    message: doc.message,
                    duration: 20,
                    key: `${data._id}-close`
                })
            }
        }

        this.setState({ loading: false })

        this.groupTable.current.reload()
    }

    replicaUserGroup = async data => {
        this.setState({ loading: true })
        let doc = await Request.replicaUserGroup(data)
        if (doc) {
            if (doc.error) {
                notification.error({
                    message: doc.message,
                    duration: 20,
                    key: `${data._id}-close`
                })
            } else {
                notification.success({
                    message: doc.message,
                    duration: 20,
                    key: `${data._id}-close`
                })
            }
        }

        this.setState({ loading: false })

        this.groupTable.current.reload()
    }

    setDefaultGroupByRights = async (val) => {
        // let groupData = {
        //     'Communication Settings': [],
        //     'Branch Management': [],
        //     'Channel Partner Management': [],
        //     'Inquiry/Lead Management': [],
        //     'Desks/Stage': [],
        //     'Others': [],
        //     'Country Management': [],
        //     'University Management': [],
        //     'Course/Program Management': [],
        //     'Reports': [],
        //     'Extra': [],

        //     'IP Management': [],
        //     'Course Finder': [],
        //     'Follow Ups': [],
        //     'Upload Documents': [],
        //     'Appointments': [],
        //     'Tasks': [],
        //     'User Management': [],
        //     'TelecallerManagement': [],
        //     'autoFollowUp': [],
        //     'CourseFinder': [],

        //     'Knowledge Base': [],
        //     'auto Follow Up': [],
        //     'Incentive': [],
        //     'Finance': [],
        //     'PayrollManagement': [],
        //     "AgreementManagement": []
        // }
        let groupData = this.state.groupsArray
        let newRights = []
        _.each(this.state.data, item => {
            let ids = _.find(val.rights, (i, key) => {
                return i.rightId === item.rightId
            })
            if (!ids) {
                if (item.rightName) {
                    val.rights.push(item)
                }
            }
        })
        let newData = _.groupBy(val.rights, (item) => {
            return item.group
        })
        _.each(newData, (item, key) => {
            if (groupData[key] !== undefined) {
                groupData[key] = item
            }
        })
        _.each(groupData, (item, key) => {
            if (key && item && item.length) {
                newRights.push({ title: key })
                item = _.sortBy(item, (itemO) => {
                    return itemO.order
                })
                _.each(item, (item1) => {
                    if (item1) {
                        item1.BranchWiseView = item1.viewByBranch
                        item1.UserWiseView = item1.viewById
                        newRights.push(item1)
                    }
                })
            }
        })

        val.rights = newRights
        this.setState({ editingGroup: val, activeKey: '2' }, () => {
            this.setState({
                editing: true
            })
        })
    }

    removeQueryParam() {
        const queryParams = new URLSearchParams(this.props.search)
        if (queryParams.has('id')) {
            window.location.href = window.location.href.replace(window.location.search, '');
        }
    }
    loadAllAllowedRights = async () => {
        let response = await Request.loadAllAllowedRights({})
        if (response) {
            this.setState({ allowedRights: response });
        }
    }
    async componentDidMount() {
        this.apiRequest();

        let searchParams = new URLSearchParams(this.props.search)
        let groupId = searchParams.get('id')
        await this.loadAllAllowedRights();

        if (groupId) {
            const params = { results: 1000, count: 1000 };
            const x = await this.groupRequestApi(params);
            const rights = x.data.find(el => el._id === groupId);
            await this.setDefaultGroupByRights(rights);
        }
    }

    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    onChange = activeKey => {
        this.setState({ activeKey })
    }

    selectRow = (y, record) => {
        if (!record.isChecked) {
            record.isChecked = false
        }
        record.isChecked = y.target.checked
        _.each(keyValue, (item, key) => {
            if (this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue[key]) > -1) {
                if (record.isChecked) {
                    if ((key !== 'viewById' && key !== 'viewByBranch' && key !== 'BranchWiseView' && key !== 'UserWiseView')) {
                        this.changeRightsCheckbox([key], y.target.checked, record)
                    }
                } else {
                    this.changeRightsCheckbox([key], y.target.checked, record)
                }
            }
        })
    }

    selectRowEdit = (y, record) => {
        if (!record.isChecked) {
            record.isChecked = false
        }
        record.isChecked = y.target.checked
        _.each(keyValue, (item, key) => {
            if (this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue[key]) > -1) {

                if (record.isChecked) {
                    if ((key !== 'viewById' && key !== 'viewByBranch' && key !== 'BranchWiseView' && key !== 'UserWiseView')) {
                        this.changeRightsCheckbox2([key], y.target.checked, record)
                    }
                } else {
                    this.changeRightsCheckbox2([key], y.target.checked, record)
                }
            }
        })
    }

    showAssignRightDrawer = () => {
        this.setState({ showRightsDrawer: true })
    }

    closeRightsDrawer = () => {
        this.setState({ showRightsDrawer: false }, () => {
            this.table.current.reload()
        })
    }

    _isSelectAll(value) {
        _.each(this.state.data, (record) => {
            if (!record.isChecked) {
                record.isChecked = false
            }
            record.isChecked = value
            _.each(keyValue, (item, key) => {
                if (this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue[key]) > -1) {
                    if (value) {
                        if (key !== 'viewByBranch' && key !== 'viewById') {
                            this.changeRightsCheckbox([key], value, record)
                        }
                    } else {
                        this.changeRightsCheckbox([key], value, record)
                    }
                }
            })
        })
    }

    onChange(checked) {
        console.log(checked)
    }

    _isSelectAllEdit(value) {
        _.each(this.state.editingGroup.rights, (record) => {
            if (!record.isChecked) {
                record.isChecked = false
            }
            record.isChecked = value
            _.each(keyValue, (item, key) => {
                if (this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue[key]) > -1) {
                    if (value) {
                        if ((key !== 'viewByBranch' && key !== 'viewById') || (key !== 'BranchWiseView' && key !== 'UserWiseView')) {
                            this.changeRightsCheckbox2([key], value, record)
                        }
                    } else {
                        this.changeRightsCheckbox2([key], value, record)
                    }
                }
            })
        })
    }

    render() {
        const { loading, data, editing, editingGroup, allowedRights, groupsArray } = this.state


        const columns = [
            {
                title: 'Name',
                key: 'displayName',
                dataIndex: 'displayName',
                searchTextName: 'displayName',
                filterRegex: true,
                width: 280,
                render: (val, record) => {
                    const obj = {
                        children: record.title ? <div className={stylesNew.headerStyle}> {record.title} </div> : (
                            <span>
                                <Checkbox
                                    checked={record.isChecked}
                                    onChange={y => {

                                        this.selectRow(y, record)
                                    }}>
                                    {' '}
                                    {val}
                                </Checkbox>
                            </span>
                        ),
                        props: {}
                    }
                    return obj
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                this.changeRightsCheckbox('add', y.target.checked)
                            }}>
                            {' '}
                            Add
                        </Checkbox>
                    </span>
                ),
                key: 'add',
                dataIndex: 'add',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <span>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['add']) > -1 ?
                                <Checkbox
                                    checked={record.add}
                                    onChange={y => {
                                        this.changeRightsCheckbox('add', y.target.checked, record)
                                    }}
                                /> : <Checkbox defaultChecked={false} disabled />}
                        </span>
                    )
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                this.changeRightsCheckbox('edit', y.target.checked)
                            }}>
                            {' '}
                            Edit
                        </Checkbox>
                    </span>
                ),
                key: 'edit',
                dataIndex: 'edit',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <span>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['edit']) > -1 ?
                                <Checkbox
                                    checked={record.edit}
                                    onChange={y => {
                                        this.changeRightsCheckbox('edit', y.target.checked, record)
                                    }}>
                                    {' '}
                                    {val}
                                </Checkbox>
                                : <Checkbox defaultChecked={false} disabled />}
                        </span>
                    )
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                this.changeRightsCheckbox('delete', y.target.checked)
                            }}>
                            {' '}
                            Delete
                        </Checkbox>
                    </span>
                ),
                key: 'delete',
                dataIndex: 'delete',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <span>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['delete']) > -1 ?
                                <Checkbox
                                    checked={record.delete}
                                    onChange={y => {
                                        this.changeRightsCheckbox('delete', y.target.checked, record)
                                    }}>
                                    {' '}
                                    {val}
                                </Checkbox>
                                : <Checkbox defaultChecked={false} disabled />}
                        </span>
                    )
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                let temp = _.clone(this.state.data)
                                _.each(temp, (val) => {
                                    if ('viewByBranch' in val) {
                                        val['viewByBranch'] = false
                                    }
                                    if ('viewById' in val) {
                                        val['viewById'] = false
                                    }
                                })
                                this.changeRightsCheckbox('view', y.target.checked)
                            }}>
                            {' '}
                            ViewAll
                        </Checkbox>
                    </span>
                ),
                key: 'view',
                dataIndex: 'view',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>
                            <span>
                                {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['view']) > -1 ?
                                    <Checkbox
                                        checked={record.view}
                                        onChange={y => {
                                            if (!y.target.checked) {
                                                if ('viewByBranch' in record) {
                                                    record.viewByBranch = false
                                                }
                                                if ('viewById' in record) {
                                                    record.viewById = false
                                                }
                                            }

                                            this.changeRightsCheckbox('view', y.target.checked, record)
                                        }}>
                                        {' '}
                                    </Checkbox>
                                    : <Checkbox defaultChecked={false} disabled />}
                            </span>
                        </div>
                    )
                }
            },
            {
                title: 'View By Branch',
                key: 'BranchWiseView',
                dataIndex: 'BranchWiseView',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['BranchWiseView']) > -1 ?
                                <Checkbox
                                    checked={record.BranchWiseView}
                                    onChange={y => {

                                        if ('UserWiseView' in record) {
                                            record.UserWiseView = false
                                        }
                                        if (y.target.checked) {
                                            if ('view' in record) {
                                                record.view = true
                                            }
                                        }

                                        this.changeRightsCheckbox(
                                            'BranchWiseView',
                                            y.target.checked,
                                            record
                                        )
                                    }}>
                                </Checkbox> : <Checkbox defaultChecked={false} disabled />}
                        </div>
                    )
                }
            },
            {
                title: 'View By User',
                key: 'UserWiseView',
                dataIndex: 'UserWiseView',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['UserWiseView']) > -1 ?
                                <Checkbox
                                    checked={record.UserWiseView}
                                    onChange={y => {
                                        if ('BranchWiseView' in record) {
                                            record.BranchWiseView = false
                                        }

                                        if (y.target.checked) {
                                            if ('view' in record) {
                                                record.view = true
                                            }
                                        }

                                        this.changeRightsCheckbox(
                                            'UserWiseView',
                                            y.target.checked,
                                            record
                                        )
                                    }}>
                                </Checkbox> : <Checkbox defaultChecked={false} disabled />}
                        </div>
                    )
                }
            }
        ]
        const columns2 = [
            {
                title: 'Name',
                key: 'displayName',
                dataIndex: 'displayName',
                searchTextName: 'displayName',
                filterRegex: true,
                width: 280,
                render: (val, record) => {
                    return (
                        <div>
                            {record.title ? <div className={stylesNew.headerStyle}> {record.title} </div> :
                                <span>
                                    <Checkbox
                                        checked={record.isChecked}
                                        onChange={y => {
                                            this.selectRowEdit(y, record)
                                        }}>
                                        {' '}
                                        {val}
                                    </Checkbox>
                                </span>
                            }
                        </div>
                    )
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                this.changeRightsCheckbox2('add', y.target.checked)
                            }}>
                            {' '}
                            Add
                        </Checkbox>
                    </span>
                ),
                key: 'add',
                dataIndex: 'add',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <span>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['add']) > -1 ?
                                <Checkbox
                                    checked={record.add}
                                    onChange={y => {
                                        this.changeRightsCheckbox2('add', y.target.checked, record)
                                    }}
                                />
                                : <Checkbox defaultChecked={false} disabled />}
                        </span>
                    )
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                this.changeRightsCheckbox2('edit', y.target.checked)
                            }}>
                            {' '}
                            Edit
                        </Checkbox>
                    </span>
                ),
                key: 'edit',
                dataIndex: 'edit',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <span>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['edit']) > -1 ?
                                <Checkbox
                                    checked={record.edit}
                                    onChange={y => {
                                        this.changeRightsCheckbox2('edit', y.target.checked, record)
                                    }}>
                                    {' '}
                                    {val}
                                </Checkbox>
                                : <Checkbox defaultChecked={false} disabled />}
                        </span>
                    )
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                this.changeRightsCheckbox2('delete', y.target.checked)
                            }}>
                            {' '}
                            Delete
                        </Checkbox>
                    </span>
                ),
                key: 'delete',
                dataIndex: 'delete',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <span>
                            {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['delete']) > -1 ?
                                <Checkbox
                                    checked={record.delete}
                                    onChange={y => {
                                        this.changeRightsCheckbox2('delete', y.target.checked, record)
                                    }}>
                                    {' '}
                                    {val}
                                </Checkbox>
                                : <Checkbox defaultChecked={false} disabled />}
                        </span>
                    )
                }
            },
            {
                title: (
                    <span>
                        <Checkbox
                            onChange={y => {
                                let temp = _.clone(editingGroup.rights)
                                _.each(temp, (val) => {
                                    if ('viewByBranch' in val) {
                                        val['viewByBranch'] = false
                                    }
                                    if ('viewById' in val) {
                                        val['viewById'] = false
                                    }
                                })


                                this.changeRightsCheckbox2('view', y.target.checked)
                            }}>
                            {' '}
                            ViewAll
                        </Checkbox>
                    </span>
                ),
                key: 'view',
                dataIndex: 'view',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>
                            <span>
                                {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['view']) > -1 ?
                                    <Checkbox
                                        checked={record.view}
                                        onChange={y => {
                                            if (!y.target.checked) {
                                                if ('viewByBranch' in record) {
                                                    record.viewByBranch = false
                                                }
                                                if ('viewById' in record) {
                                                    record.viewById = false
                                                }
                                            }
                                            this.changeRightsCheckbox2('view', y.target.checked, record)
                                        }}>
                                        {' '}
                                    </Checkbox>
                                    : <Checkbox defaultChecked={false} disabled />}
                            </span>
                        </div>
                    )
                }
            },
            {
                title: 'Branch Wise View',
                key: 'viewByBranch',
                dataIndex: 'viewByBranch',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>
                            <React.Fragment>
                                {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['BranchWiseView']) > -1 ?
                                    <Checkbox
                                        checked={record.viewByBranch}
                                        onChange={y => {
                                            if ('UserWiseView' in record) {
                                                record.viewById = false
                                            }
                                            if (y.target.checked) {
                                                if ('view' in record) {
                                                    record.view = true
                                                }
                                            }

                                            this.changeRightsCheckbox2(
                                                'BranchWiseView',
                                                y.target.checked,
                                                record
                                            )
                                            this.changeRightsCheckbox2(
                                                'viewByBranch',
                                                y.target.checked,
                                                record
                                            )
                                        }}>
                                    </Checkbox> : <Checkbox defaultChecked={false} disabled />}

                            </React.Fragment>
                        </div>
                    )
                }
            },
            {
                title: 'User Wise View',
                key: 'viewById',
                dataIndex: 'viewById',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>
                            <React.Fragment>


                                {this.state.masterRightObj[record.rightName] && this.state.masterRightObj[record.rightName].indexOf(keyValue['UserWiseView']) > -1 ?
                                    <Checkbox
                                        checked={record.viewById}
                                        onChange={y => {
                                            if ('BranchWiseView' in record) {
                                                record.viewByBranch = false
                                            }
                                            if (y.target.checked) {
                                                if ('view' in record) {
                                                    record.view = true
                                                }
                                            }
                                            this.changeRightsCheckbox2(
                                                'UserWiseView',
                                                y.target.checked,
                                                record
                                            )
                                            this.changeRightsCheckbox2(
                                                'viewById',
                                                y.target.checked,
                                                record
                                            )
                                        }}>
                                    </Checkbox> : <Checkbox defaultChecked={false} disabled />}
                            </React.Fragment>
                        </div>
                    )
                }
            }
        ]
        const groupColumns = [
            {
                title: 'Group Name',
                key: 'groupName',
                dataIndex: 'groupName',
                searchTextName: 'groupName',
                filterRegex: true,

            },
            {
                title: 'Dashboard',
                key: 'dashboard',
                dataIndex: 'dashboard'
            },
            {
                title: 'Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'Updated By',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).local().format(setting.masterFormat) : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                key: 'actions',
                title: 'Actions',
                width: 100,
                fixed: 'right',
                render: (val, record) => {
                    return (
                        <div>
                            <Tooltip title="Edit Details">
                                <Button
                                    shape="circle"
                                    size="small"
                                    style={{ marginRight: '5px' }}
                                    // onClick={() => {
                                    //     let groupData = groupsArray;
                                    //     // if (allowedRights.includes('All Students')) {
                                    //     //     groupData["All Student Fields"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Desk Management')) {
                                    //     //     groupData["Desks/Stage"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('User Management')) {
                                    //     //     groupData["User Management"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Template')) {
                                    //     //     groupData["Template"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Calls')) {
                                    //     //     groupData["Calls"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Knowledge Bank')) {
                                    //     //     groupData["Knowledge Base"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Ip Management')) {
                                    //     //     groupData["IP Management"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Agreement Management')) {
                                    //     //     groupData["AgreementManagement"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Appointments')) {
                                    //     //     groupData["Appointments"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('OverAll Reports')) {
                                    //     //     groupData["Overall Reports"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Task Management')) {
                                    //     //     groupData["Tasks"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Leads')) {
                                    //     //     groupData["Inquiry/Lead Management"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Communication Settings')) {
                                    //     //     groupData["Communication Settings"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Payroll Management')) {
                                    //     //     groupData["PayrollManagement"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Follow Ups')) {
                                    //     //     groupData["Follow Ups"] = [];
                                    //     //     groupData["autoFollowUp"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Upload Documents')) {
                                    //     //     groupData["Upload Documents"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Master Management')) {
                                    //     //     groupData["Channel Partner Management"] = [];
                                    //     //     groupData["Country Management"] = [];
                                    //     //     groupData["University Management"] = [];
                                    //     //     groupData["Course/Program Management"] = [];
                                    //     //     groupData["BoardsManagement"] = [];
                                    //     //     groupData["Restricted Area"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Reports')) {
                                    //     //     groupData["Reports"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Finance Management')) {
                                    //     //     groupData["Finance"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('UseFull Links')) {
                                    //     //     groupData["UsefullLinks"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('Branch Management')) {
                                    //     //     groupData["Branch Management"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('TelecallerManagement')) {
                                    //     //     groupData["TelecallerManagement"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('CourseFinder')) {
                                    //     //     groupData["CourseFinder"] = [];
                                    //     // }
                                    //     // if (allowedRights.includes('IVRGroup')) {
                                    //     //   groupData["IVRGroup"] = [];
                                    //     // }

                                    //     let newRights = []
                                    //     _.each(data, item => {
                                    //         let ids = _.find(val.rights, (i, key) => {
                                    //             return i.rightId === item.rightId
                                    //         })
                                    //         if (!ids) {
                                    //             if (item.rightName) {
                                    //                 val.rights.push(item)
                                    //             }
                                    //         }
                                    //     })
                                    //     let newData = _.groupBy(val.rights, (item) => {
                                    //         return item.group
                                    //     })
                                    //     _.each(newData, (item, key) => {
                                    //         if (groupData[key] !== undefined) {
                                    //             groupData[key] = item
                                    //         }
                                    //     })
                                    //     _.each(groupData, (item, key) => {
                                    //         if (key && item && item.length) {
                                    //             newRights.push({ title: key })
                                    //             item = _.sortBy(item, (itemO) => {
                                    //                 return itemO.order
                                    //             })
                                    //             _.each(item, (item1) => {
                                    //                 if (item1) {
                                    //                     item1.BranchWiseView = item1.viewByBranch
                                    //                     item1.UserWiseView = item1.viewById
                                    //                     newRights.push(item1)
                                    //                 }
                                    //             })
                                    //         }
                                    //     })
                                    //     val.rights = newRights
                                    //     this.setState({ editingGroup: val, activeKey: '2' }, () => {
                                    //         this.setState({
                                    //             editing: true
                                    //         })
                                    //     })
                                    // }}
                                    onClick={() => {
                                        let groupData = groupsArray;

                                        let newRights = []
                                        _.each(data, item => {
                                            let ids = _.find(val.rights, (i, key) => {
                                                return i.rightId === item.rightId
                                            })
                                            if (!ids) {
                                                if (item.rightName) {
                                                    val.rights.push(item)
                                                }
                                            }
                                        })
                                        let newData = _.groupBy(val.rights, (item) => {
                                            return item.group
                                        })
                                        _.each(newData, (item, key) => {
                                            if (groupData[key] !== undefined) {
                                                groupData[key] = item
                                            }
                                        })
                                        _.each(groupData, (item, key) => {
                                            if (key && item && item.length) {
                                                newRights.push({ title: key })
                                                item = _.sortBy(item, (itemO) => {
                                                    return itemO.order
                                                })
                                                _.each(item, (item1) => {
                                                    if (item1) {
                                                        item1.BranchWiseView = item1.viewByBranch
                                                        item1.UserWiseView = item1.viewById
                                                        newRights.push(item1)
                                                    }
                                                })
                                            }
                                        })
                                        val.rights = newRights
                                        this.setState({ editingGroup: val, activeKey: '2' }, () => {
                                            this.setState({
                                                editing: true
                                            })
                                        })
                                    }}
                                    icon="edit"
                                />
                            </Tooltip>

                            <Tooltip title="Replica Group">
                                <Popconfirm
                                    title="Are you sure replica this UserGroup?"
                                    onConfirm={() => {
                                        this.replicaUserGroup({ _id: record._id })
                                    }}
                                    onCancel={() => {
                                        console.log()
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        className={styles.btn}
                                        size={'small'}
                                        shape="circle"
                                        icon="copy"
                                    />
                                </Popconfirm>
                            </Tooltip>

                            <Tooltip title="Delete UserGroup">
                                <Popconfirm
                                    title="Are you sure delete this UserGroup?"
                                    onConfirm={() => {
                                        this.deleteUserGroup({ _id: record._id })
                                    }}
                                    onCancel={() => {
                                        console.log()
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        className={styles.btn}
                                        size={'small'}
                                        shape="circle"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </div>
                    )
                }
            }
        ]

        // const formItemLayout = {
        //     labelCol: {
        //         xs: {span: 24},
        //         sm: {span: 8},
        //         md: {span: 8}
        //     },
        //     wrapperCol: {
        //         xs: {span: 24},
        //         sm: {span: 16},
        //         md: {span: 12}
        //     }
        // }
        // const submitFormLayout = {
        //     wrapperCol: {
        //         xs: {span: 24, offset: 0},
        //         sm: {span: 10, offset: 7},
        //         md: {span: 12, offset: 8}
        //     }
        // }

        return (
            <PageHeaderWrapper title={'Groups'}>
                {
                    this.state.showRightsDrawer ?
                        <RightsToAll groups={this.state.groups} groupsArray={this.state.groupsArray} moduleNames={this.state.moduleNames} onClose={this.closeRightsDrawer} />
                        : null
                }
                <Card bordered={true}>
                    <Tabs
                        activeKey={this.state.activeKey}
                        defaultActiveKey="0"
                        onChange={this.onChange}
                        type="card">
                        <TabPane disabled={editing} tab={'Add Group'} key={0}>
                            <FormComp
                                handleSubmit={this.handleSubmit}
                                loading={this.props.loading}
                            />
                            <div className={common.btnGroup}>
                                <Button
                                    size="small"
                                    type="default" onClick={() => this._isSelectAll(true)}>
                                    Select All
                                </Button>
                                <Button
                                    size="small"
                                    type="default" onClick={() => this._isSelectAll(false)}>
                                    De-Select All
                                </Button>
                            </div>
                            {/* <div>
                                    {Object.keys(newRights).map(function(key, index) {
                                    return (
                                        <div key={key} style={{ marginTop: 10 }}>
                                        <h3>{key}</h3>
                                        <Table
                                            columns={columns}
                                            loading={loading}
                                            dataSource={newRights[key]}
                                            pagination={false}
                                            size="small"
                                            bordered
                                        />
                                        </div>
                                    )
                                    })}
                                </div>*/}
                            <br />
                            <TableComp
                                columns={columns}
                                ref={this.table}
                                loading={loading}
                                // apiRequest={(params)=>this.apiRequest(params,columns)}
                                dataSource={data}
                                size={'small'}
                                bordered
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 1000,
                                    pageSizeOptions: ["10", "20", "50", "100", "1000"],
                                }}
                            />
                        </TabPane>

                        <TabPane disabled={editing} tab={'Groups List'} key={1}>
                            <h2>{`Groups : ${this.state.groupCount}`}</h2>
                            <Card style={{ marginBottom: 10 }}>
                                <div>
                                    <Col span={8}>
                                        <label>Filter by module name</label>
                                        <Select
                                            allowClear
                                            style={{
                                                width: 225,
                                                marginRight: 16
                                            }}
                                            showSearch={true}
                                            className={common.width100Pr}
                                            value={this.state.moduleName}
                                            placeholder="Select Option"
                                            optionFilterProp="display"
                                            onChange={moduleName => {
                                                this.setState(
                                                    {
                                                        moduleName: moduleName
                                                    },
                                                    () => {
                                                        setTimeout(() => {
                                                            this.groupTable.current.reload()
                                                        }, 500);
                                                    }
                                                );
                                            }}>
                                            <Option value={''}>Show All</Option>
                                            {this.state.moduleNames.map((val, idn) => {
                                                return (
                                                    <Option key={idn} value={val}>
                                                        {val}
                                                    </Option>
                                                )
                                            })}
                                        </Select>
                                    </Col>
                                    <Col span={4}>
                                        <Button type='primary' onClick={() => this.showAssignRightDrawer()}>Assign Rights</Button>
                                    </Col>
                                </div>
                            </Card>
                            <TableComp
                                columns={groupColumns}
                                ref={this.groupTable}
                                apiRequest={params => this.groupRequestApi(params)}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 1000,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </TabPane>

                        {editing && (
                            <TabPane
                                tab={
                                    <span>
                                        Edit Group
                                        <Button
                                            onClick={() => {
                                                this.setState({
                                                    editing: false,
                                                    editingGroup: null,
                                                    activeKey: '0'
                                                }, () => {
                                                    this.groupTable.current && this.groupTable.current.reload()
                                                    this._isSelectAll(false)
                                                    this.removeQueryParam();
                                                })
                                            }}>
                                            <Icon
                                                type="close-circle"
                                                theme="twoTone"
                                                twoToneColor="#52c41a"
                                            />
                                        </Button>
                                    </span>
                                }
                                key={2}>
                                <FormComp
                                    data={{ groupName: editingGroup.groupName, dashboard: editingGroup.dashboard }}
                                    handleSubmit={this.handleSubmit}
                                    loading={this.props.loading}
                                />
                                <div className={common.btnGroup}>
                                    <Button
                                        size="small"
                                        type="default" onClick={() => this._isSelectAllEdit(true)}>
                                        Select All
                                    </Button>
                                    <Button
                                        size="small"
                                        type="default" onClick={() => this._isSelectAllEdit(false)}>
                                        De-Select All
                                    </Button>
                                </div>
                                {/* <TableComp
                  columns={columns2}
                  ref={this.table}
                  loading={loading}
                  dataSource={editingGroup.rights}
                  // apiRequest={(params) => this.apiRequest(params, columns)}
                  pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 1000,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                  }}
                />*/}
                                <br />
                                <Table
                                    columns={columns2}
                                    ref={this.table}
                                    loading={loading}
                                    size={'small'}
                                    bordered
                                    dataSource={editingGroup.rights}
                                    pagination={false}
                                />
                            </TabPane>
                        )}
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddGroup)
